import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const SEARCH_ALARMS = 'SEARCH_ALARMS' // 告警列表信息查询
const POST_ALARMS = 'POST_ALARMS' // 新增告警信息
const UPDATE_ALARM_STATUS = 'UPDATE_ALARM_STATUS' // 更改告警状态
const UPDATE_ALARM = 'UPDATE_ALARM' // 编辑告警信息
const SEARCH_REMARKS = 'SEARCH_REMARKS' // 备注信息查询
const PATCH_REMARKS = 'PATCH_REMARKS' // 新增备注
const DELETE_REMARK = 'DELETE_REMARK' // 删除备注

const defaultState = Immutable.fromJS({
  alarmList: {
    list: [],
    total: 0
  },
  remarkList: {
    list: [],
    total: 0
  }
})

export const alarmAction = createActions({
  SEARCH_ALARMS: async params => {
    const result = await fetch.post(`/alarm/searchAlarms`, params)
    return result
  },
  POST_ALARMS: async params => {
    const result = await fetch.post(`/alarm/postAlarms`, params)
    return result
  },
  UPDATE_ALARM_STATUS: async params => {
    const result = await fetch.post('/alarm/updateAlarmStatus', params)
    return result
  },
  UPDATE_ALARM: async params => {
    const result = await fetch.post('/alarm/updateAlarm', params)
    return result
  },
  SEARCH_REMARKS: async params => {
    const result = await fetch.post('/alarm/searchRemarks', params, {}, 8000)
    return result
  },
  PATCH_REMARKS: async params => {
    const result = await fetch.post('/alarm/patchRemarks', params)
    return result
  },
  DELETE_REMARK: async params => {
    const result = await fetch.post('/alarm/deleteRemark', params)
    return result
  }
})

const reducer = handleActions(
  {
    [SEARCH_ALARMS]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'alarmList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [SEARCH_REMARKS]: (state, action) => {
        let curState = state
        const { totalCount, records } = action.payload
        curState = curState.set(
          'remarkList',
          new Map({
            list: new List(records),
            total: totalCount
          })
        )
        return curState
    }
  },
  defaultState
)

export default reducer
